import { graphGetAll } from '@/graph/client';
import { CAPABILITY_SCOPES } from '@/auth/scopes';
import type { SubscribedSku } from '@/graph/types';

/**
 * C2 — the tenant's purchased SKUs and their service plans. This is the raw
 * material the entitlement engine reasons over.
 */
export function getSubscribedSkus(): Promise<SubscribedSku[]> {
  return graphGetAll<SubscribedSku>('/subscribedSkus', {
    scopes: CAPABILITY_SCOPES.C2.scopes,
  });
}
